<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px">
                <col>
            </colgroup>
            <tbody>
            <tr>
                <td class="c_t_title">노출상태</td>
                <td>
                    <div>
                        <el-radio-group v-model="display" @change="parentChange('display', display)">
                            <el-radio :label="1" value="1">노출</el-radio>
                            <el-radio :label="0" value="false">노출중지</el-radio>
                        </el-radio-group>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">제목</td>
                <td>
                    <div>
                        <el-input v-model="title" maxlength="20" @input="parentChange('title',title)"></el-input>
                        <div class="input_error">{{ validation.firstError('title') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">메인 이미지</td>
                <td>
                    <div class="d_block">
                        <el-upload
                            action=""
                            class="avatar-uploader"
                            list-type="picture-card"
                            :auto-upload="false"
                            :show-file-list="false"
                            :file-list="files"
                            :on-change="onlyOnePhotoChange"
                            style="display: inline-block"
                        >
                            <i class="el-icon-plus avatar-uploader-icon"
                               v-if="files.length === 0"></i>
                            <div v-else >
                                <img :src="files[0].org_url" alt="" class="avatar">
                            </div>
                            <div class="el-upload__tip" style="font-size:14px; color:red;"
                                 slot="tip">권장이미지: 150px * 150px
                            </div>
                        </el-upload>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">해시태그</td>
                <td>
                    <div>
                        <el-checkbox-group v-model="hashtag" @change="parentChange('hashtag', hashtag)">
                            <el-checkbox v-for="label in hashList" :key="label.lh_hash"
                                         :label="label.lh_idx" >{{label.lh_hash}}
                            </el-checkbox>
                        </el-checkbox-group>
                        <div class="input_error">{{validation.firstError('hashtag') }}</div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
import ThemeValidator from "@/mixins/validators/ThemeValidator";
import EventBus from "@/mixins/event-bus";
import util from "@/mixins/util";
import elFileMixins from "@/mixins/elFileMixins";
import lookbookValidator from "@/mixins/validators/LookbookValidator";

export default {
    name: "LookbookWriteThemeLayout",
    mixins: [ elFileMixins,lookbookValidator],
    components: {},
    inject: {
        lookbookWriteSetData: {
            default: () => {
            }
        },
    },
    provide() {
        return {}
    },
    props: {
        lookbookData: {
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            hashList: [],
        }
    },
    created() {
        this.getHashList();
    },
    mounted() {
        if (this.hasData()) {
            this.initSetData();
        }
        EventBus.$on('LookbookWriteThemeLayoutValidator', this.checkValidator);
    },
    beforeDestroy() {
        EventBus.$off('LookbookWriteThemeLayoutValidator')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        parentChange(key, value) {
            this.lookbookWriteSetData(key, value)
        },
        getHashList() {
            EventBus.$emit('apiLoading', true)
            this.tableLoading = true;
            let params = {}
            try {
                this.$api.$lookbook.getHash(params).then(data => {
                    let res = data.Data.Result;
                    if (res.Info.Type === 1) {
                        this.hashList = res.List;
                    }
                });
            } catch (e) {
                console.log(e);
            }
            EventBus.$emit('apiLoading', false);
        },
        checkValidator(dataArr) {
            this.$validate(dataArr)
        },
        initSetData() {
            this.display = this.lookbookData.lt_display;
            this.parentChange('display', this.display);
            this.title = this.lookbookData.lt_title;
            this.parentChange('title', this.title);
            if(!util.isEmpty(this.lookbookData.ThemeFiles)) {
                this.files = this.lookbookData.ThemeFiles
                this.parentChange('files', this.files);
            }
            if (!util.isEmpty(this.lookbookData.Hash)) {
                util.Array.each(this.lookbookData.Hash, (value, index, arr) => {
                    this.hashtag.push(value.lh_idx);
                })
                this.parentChange('hashtag', this.hashtag)
            }
        },
        hasData() {
            return !util.isEmpty(this.lookbookData);
        },
    },
    watch: {
        'lookbookData': {
            deep: true,
            handler: function () {
                this.initSetData();
            },
        }
    },
}
</script>

<style scoped>

</style>
